<template>
  <div class="points">
    <h2 class="points__title">{{ data.Title }}</h2>
    <div class="points__items">
      <div class="points__item" v-for="(point, index) in data.PointsContent" :key="index">
        <div class="points__itemNumber">{{ index + 1 }}</div>
        <div class="points__itemContent" v-html="point.Content" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Points',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped lang="scss">
.points {
  padding: 1.5rem 0;
  max-width: 92rem;

  &__title {
    margin-bottom: 2rem;
    font-size: 1.8rem;
    line-height: 1.3;
    font-weight: 500;
  }

  &__item {
    position: relative;
    display: flex;
    padding-bottom: 4.6rem;

    &:last-of-type {
      padding-bottom: 0;

      &::before {
        display: none;
      }
    }

    &::before {
      content: '';
      position: absolute;
      top: calc(4.8rem + 1.1rem);
      left: 2.4rem;
      width: 1px;
      height: calc(100% - 4.8rem - 2.2rem);
      background-color: $cMain;
    }
  }

  &__itemNumber {
    display: flex;
    flex: 0 0 4.8rem;
    max-width: 4.8rem;
    height: 4.8rem;
    align-items: center;
    justify-content: center;
    background-color: $cMain;
    border-radius: 50%;
    font-family: $fSecond;
    font-size: 1.9rem;
    color: $cWhite;

    @include rwd('small-tablet') {
      flex: 0 0 3.5rem;
      max-width: 3.5rem;
      height: 3.5rem;
      font-size: 1.6rem;
    }
  }

  &__itemContent {
    flex: 1;
    padding-left: 2rem;
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: $cMainLight;

    @include rwd('tablet') {
      font-size: 1.4rem;
      line-height: 2rem;
    }

    @include rwd('small-tablet') {
      padding-left: 1.5rem;
    }

    ::v-deep {
      h3 {
        font-weight: 600;
        color: $cMainDark;
      }

      p {
        margin-bottom: 1em;

        &:last-of-type {
          margin-bottom: 0;
        }
      }

      a {
        color: $cSec;
        transition: color $tr;

        &:hover {
          color: $cSecHover;
        }
      }

      ol {
        padding-left: 1em;
        list-style-type: lower-alpha;
      }
    }
  }
}
</style>
